import React from 'react';
import PropTypes from 'prop-types';

export class AdminNavTab extends React.Component {
  render() {
    const { isActive, url, text } = this.props;
    if (isActive) {
      return <a className='nav-item is-tab is-active' href={url}><span className='tag is-light'>{text}</span></a>;
    } else {
      return <a className='nav-item is-tab' href={url}><span className='tag is-white'>{text}</span></a>;
    }
  }
}

AdminNavTab.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  isActive: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/components/adminNavbar/components/AdminNavTab.jsx